import React from "react";
import { Helmet } from "react-helmet";
import Navigation from "../../components/Navigation";
import Event from "../../assets/venue_white.jpg";
import VenueWhite from "../../assets/venue_white15.jpg";
import Private from "../../assets/private.png";
import Corporate from "../../assets/corporate.png";
import Special from "../../assets/birthday.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Home.css";

export default function Home() {
  return (
    <div className="Home">
      <Helmet>
        <title>
          Sixth & Main Event Center - Premier Venue for Events in Robstown, TX
        </title>

        {/* SEO description */}
        <meta
          name="description"
          content="Discover Sixth & Main Event Center — an all-inclusive event venue in Robstown, TX. Our rental packages include stylish décor, tables, chairs, linens, and essential supplies for your private, corporate, or special occasion. Reserve your venue rental space now!"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Sixth & Main Event Center - Premier Venue for Events in Robstown, TX"
        />
        <meta
          property="og:description"
          content="Discover Sixth & Main Event Center — an all-inclusive event venue in Robstown, TX. Our rental packages include stylish décor, tables, chairs, linens, and essential supplies for your private, corporate, or special occasion. Reserve your venue rental space now!"
        />
        <meta
          property="og:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />
        <meta
          property="og:url"
          content="https://sixthandmaineventcenter.com/"
        />
        <meta
          property="og:type"
          content="website"
        />

        {/* Twitter Card */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:title"
          content="Sixth & Main Event Center - Premier Venue for Events in Robstown, TX"
        />
        <meta
          name="twitter:description"
          content="Discover Sixth & Main Event Center, the perfect venue for private events, corporate events, and special occasions in Robstown, TX. Reserve your venue rental space now!"
        />
        <meta
          name="twitter:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://sixthandmaineventcenter.com/"
        />

        {/* JSON-LD structured data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "EventVenue",
              "name": "Sixth & Main Event Center",
              "image": [
                "https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
              ],
              "@id": "https://sixthandmaineventcenter.com",
              "url": "https://sixthandmaineventcenter.com",
              "telephone": "+1-361-765-6189",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "101 N 6th St Unit A",
                "addressLocality": "Robstown",
                "addressRegion": "TX",
                "postalCode": "78380",
                "addressCountry": "US"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 27.7899,
                "longitude": -97.6623
              },
              "openingHoursSpecification": [
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday"
                  ],
                  "opens": "08:00",
                  "closes": "20:00"
                },
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "Saturday",
                    "Sunday"
                  ],
                  "opens": "10:00",
                  "closes": "20:00"
                }
              ],
              "priceRange": "$$"
            }
          `}
        </script>
      </Helmet>
      <div className="hero">
        <Navigation />
        <div className="container">
          <div className="row">
            <div
              name="home"
              className="col-12"
            >
              <h1 className="text-center px-2">
                Host your dream event <br />
                at our boutique venue
              </h1>

              <a
                href="/reservation"
                className="btn btn-primary d-block mx-auto mt-4 py-md-3 text-uppercase"
                role="button"
                id="book-now"
              >
                <FontAwesomeIcon
                  icon={icon({
                    name: "calendar-days",
                    family: "duotone",
                    style: "solid",
                  })}
                  className="me-2"
                />
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="main">
        <div
          className="container section"
          style={{ maxWidth: "1800px" }}
        >
          <div className="primary row px-lg-5">
            <div className="col-12 col-lg-6 my-auto px-lg-5">
              <h3 className="mb-3 text-center text-lg-start">
                Private Event Space in Historic Downtown Robstown
              </h3>
              <p className="text-center text-lg-start">
                Welcome to Sixth & Main Event Center, your premier destination
                for intimate gatherings & celebrations in the heart of Robstown,
                Texas.
              </p>

              <p className="text-center text-lg-start">
                Our charming venue, nestled at the corner of 6th & Main Avenue,
                offers a versatile space that can accommodate up to 75 guests
                for a variety of events.
              </p>

              {/*<a
                href="/reservation"
                className="btn btn-primary text-uppercase mb-4"
                role="button"
                id="availability-btn"
              >
                <FontAwesomeIcon
                  icon={icon({
                    name: "calendar-days",
                    family: "duotone",
                    style: "solid",
                  })}
                  className="mx-2"
                />
                View Availability
              </a>*/}
            </div>

            <div className="col-12 col-lg-6 px-lg-5">
              <img
                src={Event}
                className="rounded-2 img-fluid py-lg-5 my-lg-5"
                alt="Exterior building that houses Sixth & Main Event Center"
              />
            </div>
          </div>
        </div>

        <div
          className="d-block d-sm-none container section"
          style={{ maxWidth: "1800px" }}
        >
          <div className="primary row px-lg-5">
            <div className="col-12 col-lg-6 my-auto px-lg-5">
              <h3 className="mb-3 text-center text-lg-start">
                Blank Canvas waiting for the Perfect Touch
              </h3>
              <p className="text-center text-lg-start">
                Our intimate venue is perfect for creating memorable experiences
                and connecting with your guests.
              </p>
            </div>

            <div className="col-12 col-lg-6 px-lg-5">
              <img
                src={VenueWhite}
                className="rounded-2 img-fluid py-lg-5 my-lg-5"
                alt="Exterior building that houses Sixth & Main Event Center"
              />
            </div>
          </div>
        </div>

        <div className="secondary section">
          <div className="text-center">
            <h2>Event Space</h2>
            <h3>Configurable for any Event Type</h3>
            <p className="text-center px-sm-3 mx-1 mt-3 mb-4">
              Whether you're planning a baby shower, a corporate holiday party,
              or any special occasion in between, Sixth & Main Event Center
              provides a customizable and elegant setting to bring your event to
              life.
            </p>
          </div>

          <div className="container px-0">
            <div
              className="row"
              id="card-row"
            >
              <div className="col-12 col-md-4">
                <div className="card px-2 pb-sm-3 mb-3 shadow">
                  <div className="card-body">
                    <div className="card-header">
                      <img
                        src={Private}
                        alt="People with balloons"
                        className="img-fluid my-auto"
                      />
                    </div>
                    <div className="card-body-content">
                      <h4>Private Events</h4>
                      <ul className="ps-4">
                        <li>Baby Showers</li>
                        <li>Bridal Showers</li>
                        <li>Graduation Parties</li>
                      </ul>
                    </div>

                    <a
                      href="/reservation"
                      className="btn btn-primary py-2 mb-2 text-uppercase"
                    >
                      Book Now
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div className="card px-2 pb-sm-3 mb-3 shadow">
                  <div className="card-header">
                    <img
                      src={Corporate}
                      alt="Corporate leader giving presentation"
                      className="img-fluid my-auto"
                    />
                  </div>

                  <div className="card-body">
                    <div className="card-body-content">
                      <h4>Corporate Events</h4>
                      <ul className="ps-4">
                        <li>Staff Appreciation</li>
                        <li>Seminars</li>
                        <li>Trainings</li>
                      </ul>
                    </div>

                    <a
                      href="/reservation"
                      className="btn btn-primary py-2 mb-2 text-uppercase"
                    >
                      Book Now
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div className="card px-2 pb-sm-3 shadow">
                  <div className="card-header">
                    <img
                      src={Special}
                      alt="Two friends sitting down at a table with a birthday cake"
                      className="img-fluid"
                    />
                  </div>

                  <div className="card-body">
                    <div className="card-body-content">
                      <h4>Special Events</h4>
                      <ul className="ps-4">
                        <li>Birthdays</li>
                        <li>Milestones</li>
                        <li>Holiday Parties</li>
                      </ul>
                    </div>

                    <a
                      href="/reservation"
                      className="btn btn-primary py-2 mb-2 text-uppercase"
                    >
                      Book Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="vision section container">
          <div className="row">
            <div className="col-12">
              <h5 className="text-white text-center">
                Bring your vision to life
              </h5>
              <a
                href="/about"
                className="btn btn-primary rounded my-3 py-3 text-uppercase text-nowrap"
                role="button"
                id="learn-more-btn-bottom"
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
